import React from "react"
import { graphql } from "gatsby"
import * as styles from "./script.module.scss"
import useScript from "../../../../hooks/use-script"

type Props = {
  id: string
  src: string
  type: string
  async: boolean
  display: boolean
}

const Script: React.FC<Props> = ({ id, src, type, async, display }) => {
  useScript(id, src, type, async)

  return <p id={id + "-script"} className={!display && styles.noDisplay}></p>
}

export const fragment = graphql`
  fragment CookiesManagementFields on DatoCmsCookiesManagement {
    id
    __typename
    url
  }
`

export default Script
